/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'add-new': {
    width: 16,
    height: 17,
    viewBox: '0 0 16 17',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" _stroke="#FFF" d="M3.5 1h12v12h-12z"/><path pid="1" _stroke="#FFF" d="M.5 4.5V16H12"/><path pid="2" _fill="#FFF" fill-opacity=".8" d="M9 10.5v-7h1v7z"/><path pid="3" _fill="#FFF" fill-opacity=".8" d="M13 7.5H6v-1h7z"/></g>'
  }
})
